import angular from 'angular';


/**

hpDownloadLink
hpAlphanumericOnly
hpMax
hpNumericOnly
hpPopover
hpRequired
hpValidDate
raCurrency
 */


import OverlayDirective from './overlay.directive';
import HPImageDirective from './hpimage.directive';
import HPDynamicTextButton from './hpDynamicTextButton.directive';
import IFrameOnloadDirective from './iframeOnload.directive';
import HPUiSelectDirective from './hpUISelect.directive';
import ModalScrollToTopDirective from './modalScrollToTop.directive';
import FileReadDirective from './fileread.directive';
import HPDownloadLinkDirective from './hpDownloadLink.directive';
import HPAlphanumericOnlyDirective from './hpAlphanumericOnly.directive';
import HPMaxDirective from './hpMax.directive';
import HPNumericOnlyDirective from './hpNumericOnly.directive';
import HPPopoverDirective from './hpPopover.directive';
import HPRequiredDirective from './hpRequired.directive';
import HPValidDateDirective from './hpValidDate.directive';
import RACurrencyDirective from './raCurrency.directive';


export default angular.module('app.common.angular.directives', [])
    .directive('hpOverlay', OverlayDirective)
    .directive('hpImage', HPImageDirective)
    .directive('hpDynamicTextButton', HPDynamicTextButton)
    .directive('iframeOnload', IFrameOnloadDirective)
    .directive('hpUiSelect', HPUiSelectDirective)
    .directive('modalScrollToTop', ModalScrollToTopDirective)
    .directive('fileread', FileReadDirective)
    .directive('hpDownloadLink', HPDownloadLinkDirective)
    .directive('hpAlphanumericOnly', HPAlphanumericOnlyDirective)
    .directive('hpMax', HPMaxDirective)
    .directive('hpNumericOnly', HPNumericOnlyDirective)
    .directive('hpRequired', HPRequiredDirective)
    .directive('hpValidDate', HPValidDateDirective)
    .directive('raCurrency', RACurrencyDirective)
    .directive('hpPopover', HPPopoverDirective)
    .run(($templateCache) => {
    // $templateCache.put('app/common/spinner/template/defaultSpinnerTemplate.html', require('./template/defaultSpinnerTemplate.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/index.js